"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyEnum = void 0;
/**
 * Валюта
 */
var CurrencyEnum;
(function (CurrencyEnum) {
  /** Неизвестная (неподдерживаемая) валюта */
  CurrencyEnum[CurrencyEnum["unknown"] = 0] = "unknown";
  /** Доллары США */
  CurrencyEnum[CurrencyEnum["usd"] = 1] = "usd";
  /** Виртуальные кредиты */
  CurrencyEnum[CurrencyEnum["credits"] = 2] = "credits";
  /** @deprecated */
  CurrencyEnum[CurrencyEnum["rur"] = 3] = "rur";
  /** Российские рубли */
  CurrencyEnum[CurrencyEnum["rub"] = 3] = "rub";
  /** Евро */
  CurrencyEnum[CurrencyEnum["eur"] = 4] = "eur";
  /** Фунт стерлингов */
  CurrencyEnum[CurrencyEnum["gbp"] = 5] = "gbp";
  /** Украинская гривна */
  CurrencyEnum[CurrencyEnum["uah"] = 6] = "uah";
  /** Белорусский рубль (не используется с 1 июля 2016) */
  CurrencyEnum[CurrencyEnum["byr"] = 7] = "byr";
  /** Белорусский рубль */
  CurrencyEnum[CurrencyEnum["byn"] = 8] = "byn";
  CurrencyEnum[CurrencyEnum["byb"] = 8] = "byb";
  /** Казахский тенге */
  CurrencyEnum[CurrencyEnum["kzt"] = 9] = "kzt";
  /** Азербайджанский манат */
  CurrencyEnum[CurrencyEnum["azn"] = 10] = "azn";
  /** Швейцарский франк */
  CurrencyEnum[CurrencyEnum["chf"] = 11] = "chf";
  /** Чешская крона */
  CurrencyEnum[CurrencyEnum["czk"] = 12] = "czk";
  /** Канадский доллар */
  CurrencyEnum[CurrencyEnum["cad"] = 13] = "cad";
  /** Польский злотый (Polish Złoty) */
  CurrencyEnum[CurrencyEnum["pln"] = 14] = "pln";
  /** Шведская крона */
  CurrencyEnum[CurrencyEnum["sek"] = 15] = "sek";
  /** Турецкая лира */
  CurrencyEnum[CurrencyEnum["try"] = 16] = "try";
  /** Китайский юань */
  CurrencyEnum[CurrencyEnum["cny"] = 17] = "cny";
  /** Индийская рупия */
  CurrencyEnum[CurrencyEnum["inr"] = 18] = "inr";
  /** Бразильский реал */
  CurrencyEnum[CurrencyEnum["brc"] = 19] = "brc";
  CurrencyEnum[CurrencyEnum["brl"] = 19] = "brl";
  /** Южноафриканский рэнд */
  CurrencyEnum[CurrencyEnum["zar"] = 20] = "zar";
  /** Узбекский сум */
  CurrencyEnum[CurrencyEnum["uzs"] = 21] = "uzs";
  /** Болгарский лев */
  CurrencyEnum[CurrencyEnum["bgl"] = 22] = "bgl";
  /** Японская йена (Japanese Yen) */
  CurrencyEnum[CurrencyEnum["jpy"] = 23] = "jpy";
  /** Норвежская крона */
  CurrencyEnum[CurrencyEnum["nok"] = 24] = "nok";
  /** Датская крона */
  CurrencyEnum[CurrencyEnum["dkk"] = 25] = "dkk";
  /** Исландская крона */
  CurrencyEnum[CurrencyEnum["isk"] = 26] = "isk";
  /** Хорватская куна */
  CurrencyEnum[CurrencyEnum["hrk"] = 27] = "hrk";
  /** Румынский лей */
  CurrencyEnum[CurrencyEnum["ron"] = 28] = "ron";
  /** Новый тайваньский доллар */
  CurrencyEnum[CurrencyEnum["twd"] = 29] = "twd";
  /** Сингапурский доллар */
  CurrencyEnum[CurrencyEnum["sgd"] = 30] = "sgd";
  /** Эмиратский дирхам */
  CurrencyEnum[CurrencyEnum["aed"] = 31] = "aed";
  /** Армянский драм */
  CurrencyEnum[CurrencyEnum["amd"] = 32] = "amd";
  /** Афгани (Афганистан) */
  CurrencyEnum[CurrencyEnum["afn"] = 33] = "afn";
  /** Албанский лек */
  CurrencyEnum[CurrencyEnum["all"] = 34] = "all";
  /** Ангольская кванза */
  CurrencyEnum[CurrencyEnum["aoa"] = 35] = "aoa";
  /** Нидерландский антильский гульден */
  CurrencyEnum[CurrencyEnum["ang"] = 36] = "ang";
  /** Аргентинское песо */
  CurrencyEnum[CurrencyEnum["ars"] = 37] = "ars";
  /** Австралийский доллар */
  CurrencyEnum[CurrencyEnum["aud"] = 38] = "aud";
  /** Азербайджанский манат */
  CurrencyEnum[CurrencyEnum["azm"] = 39] = "azm";
  /** Боснийско-герцеговинский динар */
  CurrencyEnum[CurrencyEnum["bam"] = 40] = "bam";
  /** Барбадосский доллар */
  CurrencyEnum[CurrencyEnum["bbd"] = 41] = "bbd";
  /** Бангладешская така */
  CurrencyEnum[CurrencyEnum["bdt"] = 42] = "bdt";
  /** Бурундийский франк */
  CurrencyEnum[CurrencyEnum["bgn"] = 43] = "bgn";
  /** Бахрейнский динар */
  CurrencyEnum[CurrencyEnum["bhd"] = 44] = "bhd";
  /** Бурундийский франк */
  CurrencyEnum[CurrencyEnum["bif"] = 45] = "bif";
  /** Брунейский доллар */
  CurrencyEnum[CurrencyEnum["bnd"] = 46] = "bnd";
  /** Ботсванская пула */
  CurrencyEnum[CurrencyEnum["bob"] = 47] = "bob";
  /** Брунейский доллар */
  CurrencyEnum[CurrencyEnum["bsd"] = 48] = "bsd";
  /** Ботсванская пула */
  CurrencyEnum[CurrencyEnum["bwp"] = 49] = "bwp";
  /** Бельгийский франк */
  CurrencyEnum[CurrencyEnum["bcf"] = 50] = "bcf";
  /** Австрийский шиллинг */
  CurrencyEnum[CurrencyEnum["ats"] = 51] = "ats";
  /** Бейлисский доллар */
  CurrencyEnum[CurrencyEnum["bzd"] = 52] = "bzd";
  /** Конголезский франк */
  CurrencyEnum[CurrencyEnum["cdf"] = 53] = "cdf";
  /** Швейцарский франк */
  CurrencyEnum[CurrencyEnum["clf"] = 54] = "clf";
  /** Колумбийское песо */
  CurrencyEnum[CurrencyEnum["cop"] = 55] = "cop";
  /** Коста-риканский колон */
  CurrencyEnum[CurrencyEnum["crc"] = 56] = "crc";
  /** Кубинское песо */
  CurrencyEnum[CurrencyEnum["cup"] = 57] = "cup";
  /** Кабо-вердийская эскудо */
  CurrencyEnum[CurrencyEnum["cve"] = 58] = "cve";
  /** Джибутийский франк */
  CurrencyEnum[CurrencyEnum["djf"] = 59] = "djf";
  /** Доминиканское песо */
  CurrencyEnum[CurrencyEnum["dop"] = 60] = "dop";
  /** Эквадорский сукре */
  CurrencyEnum[CurrencyEnum["ecs"] = 61] = "ecs";
  /** Египетский фунт */
  CurrencyEnum[CurrencyEnum["egp"] = 62] = "egp";
  /** Эритрейская накфа */
  CurrencyEnum[CurrencyEnum["ern"] = 63] = "ern";
  /** Эфиопский быр */
  CurrencyEnum[CurrencyEnum["etb"] = 64] = "etb";
  /** Фиджийский доллар */
  CurrencyEnum[CurrencyEnum["fjd"] = 65] = "fjd";
  /** Фолклендские острова (Фолклендские острова) */
  CurrencyEnum[CurrencyEnum["fkp"] = 66] = "fkp";
  /** Французский франк */
  CurrencyEnum[CurrencyEnum["frf"] = 67] = "frf";
  /** Гамбийский даласи */
  CurrencyEnum[CurrencyEnum["gmd"] = 68] = "gmd";
  /** Грузинский лари */
  CurrencyEnum[CurrencyEnum["gel"] = 69] = "gel";
  /** Ганский седи */
  CurrencyEnum[CurrencyEnum["ghc"] = 70] = "ghc";
  /** Гибралтарский фунт */
  CurrencyEnum[CurrencyEnum["gip"] = 71] = "gip";
  /** Гвинейский франк */
  CurrencyEnum[CurrencyEnum["gnf"] = 72] = "gnf";
  /** Гватемальский кетсаль */
  CurrencyEnum[CurrencyEnum["gtq"] = 73] = "gtq";
  /** Гайанский доллар */
  CurrencyEnum[CurrencyEnum["gyd"] = 74] = "gyd";
  /** Гондурасское лемпира */
  CurrencyEnum[CurrencyEnum["hnl"] = 75] = "hnl";
  /** Хонг-конгский доллар */
  CurrencyEnum[CurrencyEnum["hkd"] = 76] = "hkd";
  /** Венгерский форинт */
  CurrencyEnum[CurrencyEnum["huf"] = 77] = "huf";
  /** Индонезийская рупия */
  CurrencyEnum[CurrencyEnum["idr"] = 78] = "idr";
  /** Иранский риал */
  CurrencyEnum[CurrencyEnum["irr"] = 79] = "irr";
  /** Израильский шекель */
  CurrencyEnum[CurrencyEnum["ils"] = 80] = "ils";
  /** Ямайский доллар */
  CurrencyEnum[CurrencyEnum["jmd"] = 81] = "jmd";
  /** Иорданский динар */
  CurrencyEnum[CurrencyEnum["jod"] = 82] = "jod";
  /** Кенияшский шиллинг */
  CurrencyEnum[CurrencyEnum["kes"] = 83] = "kes";
  /** Киргизский сом */
  CurrencyEnum[CurrencyEnum["kgs"] = 84] = "kgs";
  /** Камбоджийский риель */
  CurrencyEnum[CurrencyEnum["khr"] = 85] = "khr";
  /** Коморский франк */
  CurrencyEnum[CurrencyEnum["kmf"] = 86] = "kmf";
  /** Северокорейская вона */
  CurrencyEnum[CurrencyEnum["krw"] = 87] = "krw";
  /** Кувейтский динар */
  CurrencyEnum[CurrencyEnum["kwd"] = 88] = "kwd";
  /** Лаосский кип */
  CurrencyEnum[CurrencyEnum["lak"] = 89] = "lak";
  /** Ливанский фунт */
  CurrencyEnum[CurrencyEnum["lbp"] = 90] = "lbp";
  /** Шри-ланкийская рупия */
  CurrencyEnum[CurrencyEnum["lkr"] = 91] = "lkr";
  /** Либерийский доллар */
  CurrencyEnum[CurrencyEnum["lrd"] = 92] = "lrd";
  /** Лесотская лоти */
  CurrencyEnum[CurrencyEnum["lsl"] = 93] = "lsl";
  /** Литовский лит */
  CurrencyEnum[CurrencyEnum["ltl"] = 94] = "ltl";
  /** Латвийский лат */
  CurrencyEnum[CurrencyEnum["lvl"] = 95] = "lvl";
  /** Ливийский динар */
  CurrencyEnum[CurrencyEnum["lyd"] = 96] = "lyd";
  /** Марокканский дирхам */
  CurrencyEnum[CurrencyEnum["mad"] = 97] = "mad";
  /** Молдавский лей */
  CurrencyEnum[CurrencyEnum["mdl"] = 98] = "mdl";
  /** Малагасийский ариари */
  CurrencyEnum[CurrencyEnum["mga"] = 99] = "mga";
  /** Македонский денар */
  CurrencyEnum[CurrencyEnum["mkd"] = 100] = "mkd";
  /** Мьянма (бирма) кьят */
  CurrencyEnum[CurrencyEnum["mmk"] = 101] = "mmk";
  /** Монгольский тугрик */
  CurrencyEnum[CurrencyEnum["mnt"] = 102] = "mnt";
  /** Макао-патака */
  CurrencyEnum[CurrencyEnum["mop"] = 103] = "mop";
  /** Мавританская огия */
  CurrencyEnum[CurrencyEnum["mro"] = 104] = "mro";
  /** Маврикийская рупия */
  CurrencyEnum[CurrencyEnum["mur"] = 105] = "mur";
  /** Мальдивская руфия */
  CurrencyEnum[CurrencyEnum["mvr"] = 106] = "mvr";
  /** Малавийская квача */
  CurrencyEnum[CurrencyEnum["mwk"] = 107] = "mwk";
  /** Мексиканское песо */
  CurrencyEnum[CurrencyEnum["mxn"] = 108] = "mxn";
  /** Малайзийский ринггит */
  CurrencyEnum[CurrencyEnum["myr"] = 109] = "myr";
  /** Намибийский доллар */
  CurrencyEnum[CurrencyEnum["nad"] = 110] = "nad";
  /** Нигерийская найра */
  CurrencyEnum[CurrencyEnum["ngn"] = 111] = "ngn";
  /** Никарагуанская кордоба */
  CurrencyEnum[CurrencyEnum["nio"] = 112] = "nio";
  /** Непальская рупия */
  CurrencyEnum[CurrencyEnum["npr"] = 113] = "npr";
  /** Новозеландский доллар */
  CurrencyEnum[CurrencyEnum["nzd"] = 114] = "nzd";
  /** Оманский риал */
  CurrencyEnum[CurrencyEnum["omr"] = 115] = "omr";
  /** Панамский бальбоа */
  CurrencyEnum[CurrencyEnum["pab"] = 116] = "pab";
  /** Перуанский новый соль */
  CurrencyEnum[CurrencyEnum["pen"] = 117] = "pen";
  /** Папуа-новогвинейский кина */
  CurrencyEnum[CurrencyEnum["pgk"] = 118] = "pgk";
  /** Филиппинское песо */
  CurrencyEnum[CurrencyEnum["php"] = 119] = "php";
  /** Пакистанская рупия */
  CurrencyEnum[CurrencyEnum["pkr"] = 120] = "pkr";
  /** Парагвайский гуарани */
  CurrencyEnum[CurrencyEnum["pyg"] = 121] = "pyg";
  /** Катарский риал */
  CurrencyEnum[CurrencyEnum["qar"] = 122] = "qar";
  /** Сербский динар */
  CurrencyEnum[CurrencyEnum["rsd"] = 123] = "rsd";
  /** Руандийский франк */
  CurrencyEnum[CurrencyEnum["rwf"] = 124] = "rwf";
  /** Саудовский риял */
  CurrencyEnum[CurrencyEnum["sar"] = 125] = "sar";
  /** Соломоновы острова */
  CurrencyEnum[CurrencyEnum["sbd"] = 126] = "sbd";
  /** Сейшельская рупия */
  CurrencyEnum[CurrencyEnum["scr"] = 127] = "scr";
  /** Суданский фунт */
  CurrencyEnum[CurrencyEnum["sdg"] = 128] = "sdg";
  /** Сент-хеленский фунт */
  CurrencyEnum[CurrencyEnum["shp"] = 129] = "shp";
  /** Сьерра-леонский леоне */
  CurrencyEnum[CurrencyEnum["sll"] = 130] = "sll";
  /** Сомалийский шиллинг */
  CurrencyEnum[CurrencyEnum["sos"] = 131] = "sos";
  /** Суринамский доллар */
  CurrencyEnum[CurrencyEnum["srd"] = 132] = "srd";
  /** Свазилендский лилангени */
  CurrencyEnum[CurrencyEnum["szl"] = 133] = "szl";
  /** Таиландский бат */
  CurrencyEnum[CurrencyEnum["thb"] = 134] = "thb";
  /** Таджикский сомони */
  CurrencyEnum[CurrencyEnum["tjs"] = 135] = "tjs";
  /** Туркменский манат */
  CurrencyEnum[CurrencyEnum["tmt"] = 136] = "tmt";
  /** Тунисский динар */
  CurrencyEnum[CurrencyEnum["tnd"] = 137] = "tnd";
  /** Тонганский паанга */
  CurrencyEnum[CurrencyEnum["top"] = 138] = "top";
  /** Угандийский шиллинг */
  CurrencyEnum[CurrencyEnum["ugx"] = 139] = "ugx";
  /** Уругвайское песо */
  CurrencyEnum[CurrencyEnum["uyu"] = 140] = "uyu";
  /** Вьетнамский донг */
  CurrencyEnum[CurrencyEnum["vnd"] = 141] = "vnd";
  /** Вануатский вату */
  CurrencyEnum[CurrencyEnum["vuv"] = 142] = "vuv";
  /** Самоанский тала */
  CurrencyEnum[CurrencyEnum["wst"] = 143] = "wst";
  /** Йеменский риал */
  CurrencyEnum[CurrencyEnum["yer"] = 144] = "yer";
  /** Замбийский квача */
  CurrencyEnum[CurrencyEnum["zmk"] = 145] = "zmk";
  /** Зимбабвийский доллар */
  CurrencyEnum[CurrencyEnum["zwl"] = 146] = "zwl";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
